import TransportFormController from './transport.form.controller';

export default {
    template: require('./transport.form.html'),
    controller: TransportFormController
};
